<template>
    <div class="page-scan-in-list">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">快遞記錄</div>
            <div class="breadcrumb-item">澳門倉記錄 差異盤點</div>
        </div>
        <div class="card-block">
            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <span class="subject-label">18100000000</span>
                </FormItem>
            </Form>
        </div>
        
        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isLoading">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <span class="title-label">物流進度</span>

            <el-steps :active="3">
                <el-step title="珠海倉入庫"></el-step>
                <el-step title="珠海倉出庫"></el-step>
                <el-step title="澳門倉入庫"></el-step>
                <el-step title="澳門倉出庫"></el-step>
                <el-step title="門店上架"></el-step>
                <el-step title="用戶簽收"></el-step>
            </el-steps>

            <br>

            <el-descriptions title="珠海倉信息" :column="2" border>

              <el-descriptions-item label="快遞單號" label-class-name="my-label" content-class-name="my-content" :contentStyle="{'text-align': 'left'}">1115683204758</el-descriptions-item>
              <el-descriptions-item label="客戶名稱" :contentStyle="{'text-align': 'left'}">Daxian</el-descriptions-item>

              <el-descriptions-item label="客戶電話" :contentStyle="{'text-align': 'left'}">222222222</el-descriptions-item>
              <el-descriptions-item label="會員號" :contentStyle="{'text-align': 'left'}">5632</el-descriptions-item>

              <el-descriptions-item label="重量(kg)" :contentStyle="{'text-align': 'left'}">1.2</el-descriptions-item>
              <el-descriptions-item label="泡重(kg)" :contentStyle="{'text-align': 'left'}">23.6</el-descriptions-item>

              <el-descriptions-item label="尺寸" :contentStyle="{'text-align': 'left'}">50x12*6</el-descriptions-item>
              <el-descriptions-item label="提貨櫃點" :contentStyle="{'text-align': 'left'}">南灣壹號店</el-descriptions-item>

              <el-descriptions-item label="代收費" :contentStyle="{'text-align': 'left'}">15</el-descriptions-item>
              <el-descriptions-item label="到付運費" :contentStyle="{'text-align': 'left'}">0</el-descriptions-item>


              <el-descriptions-item label="入庫時間" :contentStyle="{'text-align': 'left'}">2021-06-28 14:20:51</el-descriptions-item>
              <el-descriptions-item label="入庫操作人" :contentStyle="{'text-align': 'left'}">aoyun002(電腦)</el-descriptions-item>

              <el-descriptions-item label="出庫時間" :contentStyle="{'text-align': 'left'}">2021-06-28 14:20:51</el-descriptions-item>
              <el-descriptions-item label="出庫操作人" :contentStyle="{'text-align': 'left'}">aoyun002(電腦)</el-descriptions-item>

              <el-descriptions-item label="出庫袋號" :contentStyle="{'text-align': 'left'}">8048451570003</el-descriptions-item>
              <el-descriptions-item label="異常件" :contentStyle="{'text-align': 'left'}">超大件</el-descriptions-item>

              <el-descriptions-item label="備註" :contentStyle="{'text-align': 'left'}"></el-descriptions-item>

            </el-descriptions>

            <br>
            <br>

            <el-descriptions title="澳門倉信息" :column="2" border>

              <el-descriptions-item label="入庫時間" label-class-name="my-label" content-class-name="my-content" :contentStyle="{'text-align': 'left'}">2021-06-29 16:20:51</el-descriptions-item>
              <el-descriptions-item label="入庫操作人" :contentStyle="{'text-align': 'left'}">澳門倉</el-descriptions-item>

              <el-descriptions-item label="出庫時間" :contentStyle="{'text-align': 'left'}">---</el-descriptions-item>
              <el-descriptions-item label="出庫操作人" :contentStyle="{'text-align': 'left'}">---</el-descriptions-item>

              <el-descriptions-item label="備註" :contentStyle="{'text-align': 'left'}"></el-descriptions-item>

            </el-descriptions>

            <br>

            <Form inline class="pg-form-inline form-input-wrap">

                <FormItem>
                    <div class="pg-btn-wrap center">
                        <div class="pg-btn style1">確定</div>
                    </div>
                </FormItem>
            </Form>
        </div>
    </div>
</template>

<script>
    import Store from '../../../assets/js/store.js'
    export default {
        data()
        {
            return {
                isShowModalRefund: false,
                isSubmitingRefund:false,
                pickShelves: [],
                pickAddress: [],
                pickAdmin: [],
                pageIndex: 1,
                curPageSize: 10,
                totalCount: 1,
                pageInput: '',
                isLoading: true,
                detail: [],
                isShowModalSign_goods: false,
                isSubmitingLog: false,
                form: {
                    odd_numbers: '',
                    username: '',
                    phone: '',
                    shelves: '',
                    arrive: '',
                    status: '',
                    start_time: '',
                    end_time: '',
                },
                table: {
                    column: [
                        {
                            title: '日期',
                            key: 'stroeName',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '入倉件數',
                            key: 'odd_numbers',
                            slot: 'odd_numbers',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '出倉件數',
                            key: 'phone',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '門店件數',
                            key: 'phone',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '智能櫃件數',
                            key: 'phone',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '宅配件數',
                            key: 'phone',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '操作',
                            sortable: true,
                            slot: 'action',
                            align: 'center',
                            minWidth: 130
                        },
                    ],
                    data: []
                },
            };
        },
        mounted()
        {
            this.getList();
        },
        methods: {
            handleModalCloseRefund(){
                this.isShowModalRefund = false;
            },
            handleRefund(index)
            {
                this.isShowModalRefund = true;
                let tableData = this.table.data;
                // this.$router.push({path: '/shopSignetodoRemark?id=' + tableData[index].id});
            },
            handleInventory(index){

            },
            handleInventory_Grid(index){
                let tableData = this.table.data;
                this.$router.push({path: '/macaoInventoryGrid'});
            },
            getShelvesList(list) //貨架號
            {
                if(list > 0) {
                    this.$Rq.requestAuth({
                        url: this.$Api.shelvesAllList,
                        method: 'get',
                        data:{
                            store_id : list,
                        }
                    }).then((res) =>
                    {
                        if (res.code == 0)
                        {
                            this.pickShelves = res.data;
                        }
                    });
                } else {
                    this.$Rq.requestAuth({
                        url: this.$Api.shelvesAllList,
                        method: 'get',
                        data:{
                            store_id : Store.fetch().store_id,
                        }
                    }).then((res) =>
                    {
                        if (res.code == 0)
                        {
                            this.pickShelves = res.data;
                        }
                    });
                }
            },
            getPickAddress() //提貨櫃點
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 1,
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.pickAddress = res.data.data;
                        if (res.data.data.length <= 1) {
                            this.form.arrive = res.data.data[0].ReceivingID;
                        }
                    }
                });
            },
            handleStoreChange(index) {
                this.$refs.resetSelect.clearSingleSelect();
                this.getShelvesList(index);
            },
            handleViewOrder(index)
            {
                this.isShowModalSign_goods = true;
                this.isSubmitingLog = true;
                let tableData = this.table.data;

                this.$Rq.requestAuth({
                    url: this.$Api.all_search,
                    method: 'get',
                    data: {
                        order: tableData[index].odd_numbers
                    }
                }).then((res) =>
                {
                    this.isSubmitingLog = false;
                    let tempArr = [];
                    let tempArr1 = [];
                    let tempArr2 = [];
                    let tempArr3 = [];
                    let tempArr4 = [];
                    let tempArr5 = [];
                    let resData = res.data;

                    if (res.code == 0)
                    {
                        for (let i = 0; i < resData.data.length; i++)
                        {
                            tempArr.push({
                                order: resData.data[i].order,
                                username: resData.data[i].username,
                                phone: resData.data[i].phone,
                            });

                            tempArr1.push({
                                weight: resData.data[i].weight,
                                size_sum: resData.data[i].long + 'x' + resData.data[i].width + 'x' + resData.data[i].height,
                                store: resData.data[i].store == null ? '- - -' : resData.data[i].store.ReceivingName,
                            });

                            tempArr2.push({
                                sack_number: resData.data[i].sack_number,
                                detailed: resData.data[i].detailed == null ? '- - -' : resData.data[i].detailed.name,
                                abnormal: resData.data[i].abnormal == 0 ? '否' : '是',
                            });

                            tempArr3.push({
                                shelves: resData.data[i].shelves == null ? '- - -' : resData.data[i].shelves.code,
                                status: resData.data[i].status,
                                created_time: resData.data[i].created_time,
                            });

                            tempArr4.push({
                                amount: resData.data[i].amount,
                                surcharge_price: resData.data[i].surcharge_price,
                                freight_collect: resData.data[i].freight_collect,
                            });

                            tempArr5.push({
                                outTime_price: resData.data[i].outTime_price,
                                total_price: Number(resData.data[i].surcharge_price) + Number(resData.data[i].outTime_price) + Number(resData.data[i].freight_collect) + Number(resData.data[i].amount),
                            });
                        }
                        this.table1.data = tempArr;
                        this.table1.data1 = tempArr1;
                        this.table1.data2 = tempArr2;
                        this.table1.data3 = tempArr3;
                        this.table1.data4 = tempArr4;
                        this.table1.data5 = tempArr5;
                    }
                }).catch((err) =>
                {
                    this.isSubmitingLog = false;
                });
            
                this.isSubmitingLog = true;
                this.$Rq.requestAuth({
                    url: this.$Api.logisticsInfo + '/' + tableData[index].odd_numbers,
                    method: 'get',
                    data: {}
                }).then((res) =>
                {
                    this.isSubmitingLog = false;
                    if (Number(res.code) == 0)
                    {
                        let resData = res.data;
                        let tempArr = [];
                        let userinfo;

                        for (let j = 0; j < resData.length; j++)
                        {
                            let datetime = this.getDateTime(resData[j].created_at);
                            
                            if(resData[j].userinfos == null){
                                if(resData[j].remarks.match(/[\u606d\u559c\u60a8]/g)){
                                    userinfo = '用戶線上支付';
                                }else{
                                    if(resData[i].admin_name != null){
                                        userinfo = resData[i].admin_name;
                                    }else{
                                        userinfo = '智能櫃派送員';
                                    }
                                }
                            }else{
                                userinfo = resData[j].userinfos.username;
                            }

                            tempArr.push({
                                userinfos: userinfo,
                                id: resData[j].id,
                                date: datetime.date,
                                week: datetime.week,
                                time: datetime.time,
                                describe: resData[j].remarks
                            });
                        }

                        this.detail = tempArr;
                    }
                }).catch((err) =>
                {
                    this.isSubmitingLog = false;
                });
            },
            getDateTime(datetime)
            {
                let date = new Date(datetime);
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let hour = date.getHours();
                let minute = date.getMinutes();
                let second = date.getSeconds();
                let week = date.getDay();
                let weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

                return {
                    date: `${this.formateNum_log(year)}-${this.formateNum_log(month)}-${this.formateNum_log(day)}`,
                    time: `${this.formateNum_log(hour)}:${this.formateNum_log(minute)}:${this.formateNum_log(second)}`,
                    week: weekList[week]
                };
            },

            formateNum_log(num)
            {
                return num > 9 ? num : '0' + num;
            },
            handleModalSignClose_goods(){
                this.isShowModalSign_goods = false;
            },
            getPickAdmin()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAdmin,
                    method: 'post'
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.pickAdmin = res.data.data;
                    }
                });
            },

            getList()
            {
                let form = this.form;

                this.isLoading = true;
                this.$Rq.requestAuth({
                    url: this.$Api.overtimelist,
                    method: 'get',
                    data: {
                        phone: form.phone,
                        storeId: form.arrive,
                        status: form.status,
                        orderNumber: form.odd_numbers,
                        start_time: form.start_time,
                        end_time: form.end_time,
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                    }
                }).then((res) =>
                {
                    this.isLoading = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;

                        if(resData == undefined)
                        {
                            this.totalCount = 0;
                            this.table.data = tempArr;
                        }
                        else
                        {

                            for (let i = 0; i < resData.length; i++)
                            {
                                tempArr.push({
                                    arriveCode: resData[i].arriveCode,
                                    arrive_time: resData[i].arrive_time,
                                    cainiao_match: resData[i].cainiao_match,
                                    odd_numbers: resData[i].orderNumber,
                                    orderStats: resData[i].orderStats,
                                    outDay: resData[i].outDay + '天',
                                    phone: resData[i].phone,
                                    status: resData[i].status,
                                    stroeName: resData[i].stroeName,
                                });
                            }

                            this.totalCount = res.data.count;
                            this.table.data = tempArr;
                        }
                    }
                }).catch(() =>
                {
                    this.isLoading = false;
                });
            },

            handleSearch()
            {
                this.pageIndex = 1;
                this.getList();
            },
            //pager
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList();
            },

            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },

            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'macaoInventoryRecordDetail.scss';
</style>